export default __webpack_public_path__ + "static/media/campaign-placeholder.fd972488.png";